import React from "react";

import { ChangeableCheckbox } from "../../../../../resource/icons";

const House = ({ house }) => {
	return (
		<div className="branch last-branch">
			<label
				onClick={(e) => {
					e.stopPropagation();
				}}
				className="checkbox-label last-branch_checkbox-label"
			>
				<input
					type="checkbox"
					className="true-checkbox"
					checked={house.checked}
					onChange={(e) => house.onSelectChange(e)}
				/>
				<ChangeableCheckbox checked={house.checked} className="checkbox" />
				<span>Дом №{house.building}</span>
				&nbsp;
				{house.corpus && (
					<span>
						корпус &nbsp;
						{house.corpus}
					</span>
				)}
			</label>
		</div>
	);
};

export default House;
